import React from 'react';

const OfficialCTASection = () => {
  return (
    <section className="py-16 md:py-24 relative overflow-hidden bg-gradient-to-b from-gray-50 to-white">
      {/* Decorative elements */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-[#96121D]/5 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-[#9B8E57]/5 rounded-full blur-3xl"></div>

      <div className="relative z-10 max-w-5xl mx-auto px-5 md:px-20 lg:px-32 text-center">
        {/* Icon */}
        <div className="mb-10 flex justify-center">
          <div className="w-16 h-16 bg-gradient-to-br from-[#96121D]/10 to-[#9B8E57]/10 rounded-xl flex items-center justify-center border border-[#9B8E57]/30">
            <svg className="w-8 h-8 text-[#96121D]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>
            </svg>
          </div>
        </div>

        {/* Title */}
        <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6 leading-tight">
          Accélérez la Transformation de Votre Organisation
        </h2>

        {/* Text */}
        <p className="text-lg md:text-xl text-gray-600 max-w-3xl mx-auto mb-10 leading-relaxed">
          Notre équipe d'experts vous accompagne dans la mise en œuvre de solutions innovantes adaptées aux enjeux stratégiques de votre institution. Bénéficiez d'un accompagnement personnalisé et de notre expertise reconnue.
        </p>

        {/* CTA Button */}
        <a
          href="/information-request-form"
          className="inline-flex items-center justify-center px-8 py-4 text-lg font-semibold text-white rounded-xl transition-all duration-300 hover:scale-105 shadow-lg hover:shadow-xl"
          style={{ backgroundColor: '#96121D' }}
        >
          <span>Demander une consultation gratuite</span>
          <svg className="w-5 h-5 ml-3 transition-transform group-hover:translate-x-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 7l5 5m0 0l-5 5m5-5H6"/>
          </svg>
        </a>
      </div>
    </section>
  );
};

export default OfficialCTASection;